/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListLockConfigRuleResponse {
    getFixupPrototypeFunction() { return ListLockConfigRuleResponse.fixupPrototype; }

    static newInstance(model: Partial<ListLockConfigRuleResponse>): ListLockConfigRuleResponse {
        let obj = Object.assign(new ListLockConfigRuleResponse(), model);
        ListLockConfigRuleResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListLockConfigRuleResponse>): ListLockConfigRuleResponse {
        if (!model) return null;
        return ListLockConfigRuleResponse.newInstance(<ListLockConfigRuleResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListLockConfigRuleResponse) {
        if (!obj) return;

        models.ListLockConfigRuleResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListLockConfigRuleResponse): boolean {
        Object.setPrototypeOf(obj, ListLockConfigRuleResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.lock_rules) {
            for (let val of this.lock_rules) {
                models.ListLockRuleModel.fixupPrototype(val);
            }
        }
    }

    lock_rules: Array<models.ListLockRuleModel>;

}
